export default __webpack_public_path__ + "static/media/django.339865f1.png";